import { render, staticRenderFns } from "./entryInfo.vue?vue&type=template&id=2b316b48&scoped=true&"
import script from "./entryInfo.vue?vue&type=script&lang=js&"
export * from "./entryInfo.vue?vue&type=script&lang=js&"
import style0 from "./entryInfo.vue?vue&type=style&index=0&id=2b316b48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b316b48",
  null
  
)

export default component.exports